import { type ForgotPasswordDto } from '../dto/forgot-password.dto';

import { type AuthToken } from '../models/token';

export function accessTokenFromForgotPasswordDto(dto: ForgotPasswordDto): AuthToken {
  return {
    key: dto.reset_token.access_token.key,
    accessExpiresAt: dto.reset_token.access_token.access_expires_at,
    refreshExpiresAt: dto.reset_token.access_token.refresh_expires_at,
  };
}
